<template>
  <v-card outlined class="rounded-lg">
    <v-card-text>
      <div class="d-flex">
        <v-autocomplete
          v-model="selectedMapId"
          :items="mapIds"
          :hint="createdAtHint"
          :loading="loadingIds"
          label="Map ID"
          filled
          dense
          persistent-hint
          item-text="alias"
          item-value="mapId"
          hide-detailse="auto"
        />
        <div>
          <v-btn
            icon
            class="ml-2"
            @click="openDialogForEditMapId(selectedMapId)"
          >
            <v-icon>{{ mdiPencil }}</v-icon>
          </v-btn>
          <v-btn
            icon
            class="mr-2"
            @click="openDialogForDeleteMapId(selectedMapId)"
          >
            <v-icon>{{ mdiDelete }}</v-icon>
          </v-btn>
        </div>
      </div>

      <v-data-table
        :headers="headers"
        :items="multimapConfigs"
        :loading="loadingMaps"
        hide-default-footer
        disable-pagination
        class="elevation-0"
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-toolbar-title>Multi-Map Global Config</v-toolbar-title>
            <v-spacer/>
            <v-dialog v-model="dialog" max-width="700px" persistent>
              <template v-slot:activator="{ on }">
                <v-btn color="primary" dark class="mb-2" v-on="on">New Value</v-btn>
              </template>
              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          v-model="editedItem.name"
                          label="Name"
                          filled
                          v-validate="{
                            required: true
                          }"
                          name="name"
                          :error-messages="errors.collect('name')"
                        />
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          v-model="editedItem.type"
                          label="Type"
                          filled
                          v-validate="{
                            required: true
                          }"
                          name="type"
                          :error-messages="errors.collect('type')"
                        />
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-select
                          v-model="editedItem.category"
                          :items="['interior', 'exterior']"
                          label="Category"
                          filled
                          v-validate="{
                            required: true
                          }"
                          name="category"
                          :error-messages="errors.collect('category')"
                        />
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          v-model="editedItem.worldWidth"
                          label="World Width"
                          filled
                          type="number"
                          v-validate="{
                            required: true
                          }"
                          name="world width"
                          :error-messages="errors.collect('world width')"
                        />
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          v-model="editedItem.worldHeight"
                          label="World Height"
                          filled
                          type="number"
                          v-validate="{
                            required: true
                          }"
                          name="world height"
                          :error-messages="errors.collect('world height')"
                        />
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          v-model="editedItem.angleOffset"
                          label="Angle offset"
                          filled
                          type="number"
                          v-validate="{
                            required: true
                          }"
                          name="Angle offset"
                          :error-messages="errors.collect('Angle offset')"
                        />
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          v-model="editedItem.pointsPerMeter"
                          label="Points per Meter"
                          filled
                          type="number"
                          v-validate="{
                            required: true
                          }"
                          name="Points per Meter"
                          :error-messages="errors.collect('Points per Meter')"
                        />
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer/>
                  <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                  <v-btn color="blue darken-1" dark @click="save">Save</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>
        <template v-slot:item.action="{ item }">
          <div class="d-flex">
            <v-btn
              icon
              small
              @click="editItem(item)"
            >
              <v-icon small>{{ mdiPencil }}</v-icon>
            </v-btn>
            <v-btn
              small
              icon
              @click="openDialogForDeleteMap(item)"
            >
              <v-icon small>{{ mdiDelete }}</v-icon>
            </v-btn>
          </div>
        </template>
      </v-data-table>
    </v-card-text>
    <v-dialog
      :value="editMapIdDialog"
      width="500"
      persistent
    >
      <v-card>
        <v-card-title>
          Edit Map ID
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="editedMapIdItem.mapId"
                  label="Map ID"
                  filled
                  :disabled="true"
                  hide-details
                />
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="editedMapIdItem.alias"
                  label="Alias"
                  filled
                  hide-details
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn color="blue darken-1" text @click="closeMapIdDialog">Cancel</v-btn>
          <v-btn color="blue darken-1" dark @click="saveMapId">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <DeleteDialog
      v-if="deleteMapIdDialog"
      :item="deletedMapId"
      @close="deleteMapIdDialog = false"
      @confirm="deleteMapId"
    />
    <DeleteDialog
      v-if="deleteMapDialog"
      :item="deletedMap"
      @close="deleteMapDialog = false"
      @confirm="deleteMap"
    />
  </v-card>
</template>

<script>
import { mdiPencil, mdiDelete } from '@mdi/js';
export default {
  components: {
    DeleteDialog: () => import('../dialogs/DeleteDialog.vue')
  },
  data() {
    return {
      mdiPencil,
      mdiDelete,
      editMapIdDialog: false,
      deleteMapIdDialog: false,
      deleteMapDialog: false,
      dialog: false,
      mapIds: [],
      selectedMapId: null,
      loadingIds: false,
      loadingMaps: false,
      headers: [
        {
          text: 'Name',
          value: 'name',
          sortable: false,
        },
        {
          text: 'Type',
          value: 'type',
          sortable: false,
        },
        {
          text: 'Category',
          value: 'category',
          sortable: false,
        },
        {
          text: 'Matrix',
          value: 'matrix',
          sortable: false,
        },
        {
          text: 'World Width',
          value: 'worldWidth',
          sortable: false,
        },
        {
          text: 'World Height',
          value: 'worldHeight',
          sortable: false,
        },
        {
          text: 'Angle Offset',
          value: 'angleOffset',
          sortable: false,
        },
        {
          text: 'Points per Meter',
          value: 'pointsPerMeter',
          sortable: false,
        },
        {
          text: 'Actions',
          value: 'action',
          align: 'center',
          sortable: false,
        },
      ],
      multimapConfigs: [],
      editedMapIdIndex: -1,
      editedMapIdItem: {
        mapId: '',
        alias: '',
        createdAt: ''
      },
      defaultMapIdItem: {
        mapId: '',
        alias: '',
        createdAt: ''
      },
      editedIndex: -1,
      editedItem: {
        name: '',
        type: '',
        category: 'exterior',
        worldWidth: 0,
        worldHeight: 0,
        angleOffset: 0,
        pointsPerMeter: 1
      },
      defaultItem: {
        name: '',
        type: '',
        category: 'exterior',
        worldWidth: 0,
        worldHeight: 0,
        angleOffset: 0,
        pointsPerMeter: 1
      },
      deletedMapId: null,
      deletedMap: null
    }
  },
  async mounted () {
    this.loadingIds = true
    const { data } = await this.$axios.get(this.$store.getters.projectPath + '/configs/multi-map')
    .catch(error => ({ data: { err: true, message: error.response.data } }))

    if (data.err) {
      this.$toasted.error(data.message)
    } else {
      this.mapIds = data
      if (data.length) {
        this.selectedMapId = data[0].mapId
      }
    }
    this.loadingIds = false
  },
  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'New Value' : 'Edit Value';
    },
    createdAtHint () {
      const val = this.mapIds.find(mapId => mapId.mapId === this.selectedMapId)
      if (val) {
        return val.createdAt
      } else {
        return ''
      }
    }
  },
  methods: {
    close () {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },
    async loadMaps () {
      const { data } = await this.$axios.get(this.$store.getters.projectPath + '/configs/multi-map/' + this.selectedMapId)
      .catch(error => ({ data: { err: true, message: error.response.data } }))

      if (data.err) {
        this.$toasted.error(data.message)
      } else {
        this.multimapConfigs = data
      }
    },
    editItem (item) {
      this.editedIndex = this.multimapConfigs.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    save () {
      this.$validator.validateAll().then(async res => {
        if (res) {
          try {
            if (this.editedIndex > -1) {
              const { data } = await this.$axios.put(this.$store.getters.projectPath + '/configs/multi-map/' + this.editedItem.id, this.editedItem);
              this.multimapConfigs.splice(this.editedIndex, 1, data);
            } else {
              const { data } = await this.$axios.post(this.$store.getters.projectPath + '/configs/multi-map', this.editedItem);
              this.multimapConfigs.push(data);
            }
          } catch(err) {
            console.log(err.message);
          }
          this.close();
        }
      })
    },
    openDialogForEditMapId (val) {
      this.editedMapIdIndex = this.mapIds.findIndex(item => item.mapId === val)
      this.editedMapIdItem = Object.assign({}, this.mapIds.find(item => item.mapId === val))
      this.editMapIdDialog = true
    },
    openDialogForDeleteMapId (val) {
      this.deletedMapId = Object.assign({}, this.mapIds.find(item => item.mapId === val))
      this.deleteMapIdDialog = true
    },
    openDialogForDeleteMap (item) {
      this.deletedMap = item
      this.deleteMapDialog = true
    },
    closeMapIdDialog () {
      this.editMapIdDialog = false;
      setTimeout(() => {
        this.editedMapIdItem = Object.assign({}, this.defaultMapIdItem)
        this.editedMapIdIndex = -1
      }, 300)
    },
    async saveMapId () {
      const { data } = await this.$axios.post(
        this.$store.getters.projectPath + '/configs/multi-map/' + this.editedMapIdItem.mapId,
        this.editedMapIdItem
      ).catch(error => ({ data: { err: true, message: error.response.data } }))

      if (data.err) {
        this.$toasted.error(data.message)
      } else {
        this.mapIds.splice(this.editedMapIdIndex, 1, { ...this.mapIds[this.editedMapIdIndex], ...this.editedMapIdItem })
      }

      this.closeMapIdDialog()
    },
    async deleteMapId (item) {
      const { data } = await this.$axios.delete(
        this.$store.getters.projectPath + '/configs/multi-map/' + item.mapId
      ).catch(error => ({ data: { err: true, message: error.response.data } }))

      if (data.err) {
        this.$toasted.error(data.message)
      } else {
        const deletedMapIdIndex = this.mapIds.findIndex(val => val.id === item.id)
        this.$delete(this.mapIds, deletedMapIdIndex)

        if (this.mapIds.length) {
          this.selectedMapId = this.mapIds[0].mapId
        }

        this.$toasted.success('MapId removed')
      }
    },
    async deleteMap (item) {
      const { data } = await this.$axios.delete(
        this.$store.getters.projectPath + '/configs/multi-map/' + this.selectedMapId + '/' + item.name + '/' + item.type
      ).catch(error => ({ data: { err: true, message: error.response.data } }))

      if (data.err) {
        this.$toasted.error(data.message)
      } else {
        const deletedMapIndex = this.multimapConfigs.findIndex(val => val.id === item.id)
        this.$delete(this.multimapConfigs, deletedMapIndex)
        this.$toasted.success('Map removed')
      }
    }
  },
  watch: {
    dialog (val) {
      val || this.close()
    },
    editMapIdDialog (val) {
      val || this.closeMapIdDialog()
    },
    async selectedMapId (val) {
      if (val) {
        await this.loadMaps()
      }
    }
  },
}
</script>